import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* eslint-disable @angular-eslint/component-selector */
class ScIconComponent {
    constructor() {
        this.icon = 'ico-info';
        this.size = 0;
        this.class = 'sc-icon';
        this.iconDir = 'gds/';
        this.iconFile = this.icon + '.svg';
    }
    get width() {
        return this.size ? this.size + 'px' : null;
    }
    get height() {
        return this.size ? this.size + 'px' : null;
    }
    ngOnInit() {
        if (this.icon) {
            this.iconDir = this.icon.split('-')[0] == 'ids' ? 'ids/' : this.iconDir;
            this.iconFile = this.icon + '.svg';
        }
    }
}
ScIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScIconComponent, selector: "[sc-icon]", inputs: { icon: "icon", size: "size" }, host: { properties: { "class.sc-icon": "this.class", "style.width": "this.width", "style.height": "this.height" } }, ngImport: i0, template: "<svg:use [attr.href]=\"'assets/icons/' + iconDir + iconFile + '#icon'\"></svg:use>", encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScIconComponent, decorators: [{
            type: Component,
            args: [{ selector: '[sc-icon]', encapsulation: ViewEncapsulation.None, template: "<svg:use [attr.href]=\"'assets/icons/' + iconDir + iconFile + '#icon'\"></svg:use>" }]
        }], propDecorators: { icon: [{
                type: Input
            }], size: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class.sc-icon']
            }], width: [{
                type: HostBinding,
                args: ['style.width']
            }], height: [{
                type: HostBinding,
                args: ['style.height']
            }] } });

class ScIconModule {
}
ScIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ScIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: ScIconModule, declarations: [ScIconComponent], imports: [CommonModule], exports: [ScIconComponent] });
ScIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScIconModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ScIconComponent],
                    exports: [ScIconComponent],
                }]
        }] });

var GdsIcons;
(function (GdsIcons) {
    GdsIcons["ICO_ACCESSIBILITY_XL"] = "ico-accessibility-xl";
    GdsIcons["ICO_ACCESSIBILITY"] = "ico-accessibility";
    GdsIcons["ICO_ACCOUNTS_XL"] = "ico-accounts-xl";
    GdsIcons["ICO_ACCOUNTS"] = "ico-accounts";
    GdsIcons["ICO_ADDRESSBOOK_XL"] = "ico-addressbook-xl";
    GdsIcons["ICO_ADDRESSBOOK"] = "ico-addressbook";
    GdsIcons["ICO_AIRPLANE_XL"] = "ico-airplane-xl";
    GdsIcons["ICO_AIRPLANE"] = "ico-airplane";
    GdsIcons["ICO_APP_CARDS_XL"] = "ico-app-cards-xl";
    GdsIcons["ICO_APP_CARDS"] = "ico-app-cards";
    GdsIcons["ICO_APP_ICON_XL"] = "ico-app-icon-xl";
    GdsIcons["ICO_APP_ICON"] = "ico-app-icon";
    GdsIcons["ICO_APP_LIST_XL"] = "ico-app-list-xl";
    GdsIcons["ICO_APP_LIST"] = "ico-app-list";
    GdsIcons["ICO_APP_STORE_ANDROID_XL"] = "ico-app-store-android-xl";
    GdsIcons["ICO_APP_STORE_ANDROID"] = "ico-app-store-android";
    GdsIcons["ICO_APP_STORE_IOS_XL"] = "ico-app-store-ios-xl";
    GdsIcons["ICO_APP_STORE_IOS"] = "ico-app-store-ios";
    GdsIcons["ICO_ARROW_DOWN_XL"] = "ico-arrow-down-xl";
    GdsIcons["ICO_ARROW_DOWN"] = "ico-arrow-down";
    GdsIcons["ICO_ARROW_FAST_FORWARD_XL"] = "ico-arrow-fast-forward-xl";
    GdsIcons["ICO_ARROW_FAST_FORWARD"] = "ico-arrow-fast-forward";
    GdsIcons["ICO_ARROW_LEFT_XL"] = "ico-arrow-left-xl";
    GdsIcons["ICO_ARROW_LEFT"] = "ico-arrow-left";
    GdsIcons["ICO_ARROW_OUT_XL"] = "ico-arrow-out-xl";
    GdsIcons["ICO_ARROW_OUT"] = "ico-arrow-out";
    GdsIcons["ICO_ARROW_RIGHT_XL"] = "ico-arrow-right-xl";
    GdsIcons["ICO_ARROW_RIGHT"] = "ico-arrow-right";
    GdsIcons["ICO_ARROW_UP_DOWN_XL"] = "ico-arrow-up-down-xl";
    GdsIcons["ICO_ARROW_UP_DOWN"] = "ico-arrow-up-down";
    GdsIcons["ICO_ARROW_UP_XL"] = "ico-arrow-up-xl";
    GdsIcons["ICO_ARROW_UP"] = "ico-arrow-up";
    GdsIcons["ICO_ARROWS_COLLAPSE_XL"] = "ico-arrows-collapse-xl";
    GdsIcons["ICO_ARROWS_COLLAPSE"] = "ico-arrows-collapse";
    GdsIcons["ICO_ARROWS_EXPAND_XL"] = "ico-arrows-expand-xl";
    GdsIcons["ICO_ARROWS_EXPAND"] = "ico-arrows-expand";
    GdsIcons["ICO_ATTACHMENT_XL"] = "ico-attachment-xl";
    GdsIcons["ICO_ATTACHMENT"] = "ico-attachment";
    GdsIcons["ICO_AUDIO_XL"] = "ico-audio-xl";
    GdsIcons["ICO_AUDIO"] = "ico-audio";
    GdsIcons["ICO_BANK_XL"] = "ico-bank-xl";
    GdsIcons["ICO_BANK"] = "ico-bank";
    GdsIcons["ICO_BANKCARD_XL"] = "ico-bankcard-xl";
    GdsIcons["ICO_BANKCARD"] = "ico-bankcard";
    GdsIcons["ICO_BARCODE_XL"] = "ico-barcode-xl";
    GdsIcons["ICO_BARCODE"] = "ico-barcode";
    GdsIcons["ICO_BARS_ARROW_OUTLINE_CZ_XL"] = "ico-bars-arrow-outline-cz-xl";
    GdsIcons["ICO_BARS_ARROW_OUTLINE_CZ"] = "ico-bars-arrow-outline-cz";
    GdsIcons["ICO_BARS_CHECK_OUTLINE_CZ_XL"] = "ico-bars-check-outline-cz-xl";
    GdsIcons["ICO_BARS_CHECK_OUTLINE_CZ"] = "ico-bars-check-outline-cz";
    GdsIcons["ICO_BARS_LINE_CHART_OUTLINE_CZ_XL"] = "ico-bars-line-chart-outline-cz-xl";
    GdsIcons["ICO_BARS_LINE_CHART_OUTLINE_CZ"] = "ico-bars-line-chart-outline-cz";
    GdsIcons["ICO_BILL_PAYMENT_XL"] = "ico-bill-payment-xl";
    GdsIcons["ICO_BILL_PAYMENT"] = "ico-bill-payment";
    GdsIcons["ICO_BLOCK_XL"] = "ico-block-xl";
    GdsIcons["ICO_BLOCK"] = "ico-block";
    GdsIcons["ICO_BRIEFCASE_XL"] = "ico-briefcase-xl";
    GdsIcons["ICO_BRIEFCASE"] = "ico-briefcase";
    GdsIcons["ICO_BROKEN_GLASS_XL"] = "ico-broken-glass-xl";
    GdsIcons["ICO_BROKEN_GLASS"] = "ico-broken-glass";
    GdsIcons["ICO_BUILDING_SAVINGS_CONTRACT_XL"] = "ico-building-savings-contract-xl";
    GdsIcons["ICO_BUILDING_SAVINGS_CONTRACT"] = "ico-building-savings-contract";
    GdsIcons["ICO_BUILDING_SAVINGS_XL"] = "ico-building-savings-xl";
    GdsIcons["ICO_BUILDING_SAVINGS"] = "ico-building-savings";
    GdsIcons["ICO_BUILDING_SOCIETY_LOAN_XL"] = "ico-building-society-loan-xl";
    GdsIcons["ICO_BUILDING_SOCIETY_LOAN"] = "ico-building-society-loan";
    GdsIcons["ICO_BURINKA_XL"] = "ico-burinka-xl";
    GdsIcons["ICO_BURINKA"] = "ico-burinka";
    GdsIcons["ICO_BUSINESS_XL"] = "ico-business-xl";
    GdsIcons["ICO_BUSINESS"] = "ico-business";
    GdsIcons["ICO_CALENDAR_XL"] = "ico-calendar-xl";
    GdsIcons["ICO_CALENDAR"] = "ico-calendar";
    GdsIcons["ICO_CAMERA_ADD_XL"] = "ico-camera-add-xl";
    GdsIcons["ICO_CAMERA_ADD"] = "ico-camera-add";
    GdsIcons["ICO_CAMERA_SWITCH_XL"] = "ico-camera-switch-xl";
    GdsIcons["ICO_CAMERA_SWITCH"] = "ico-camera-switch";
    GdsIcons["ICO_CAMERA_XL"] = "ico-camera-xl";
    GdsIcons["ICO_CAMERA"] = "ico-camera";
    GdsIcons["ICO_CAR_INSURANCE_XL"] = "ico-car-insurance-xl";
    GdsIcons["ICO_CAR_INSURANCE"] = "ico-car-insurance";
    GdsIcons["ICO_CARD_ACTIVATE_XL"] = "ico-card-activate-xl";
    GdsIcons["ICO_CARD_ACTIVATE"] = "ico-card-activate";
    GdsIcons["ICO_CARD_ADDITIONAL_XL"] = "ico-card-additional-xl";
    GdsIcons["ICO_CARD_ADDITIONAL"] = "ico-card-additional";
    GdsIcons["ICO_CARD_CREDITCARD_XL"] = "ico-card-creditcard-xl";
    GdsIcons["ICO_CARD_CREDITCARD"] = "ico-card-creditcard";
    GdsIcons["ICO_CARD_HEALTHINSURANCE_XL"] = "ico-card-healthinsurance-xl";
    GdsIcons["ICO_CARD_HEALTHINSURANCE"] = "ico-card-healthinsurance";
    GdsIcons["ICO_CARD_NEW_XL"] = "ico-card-new-xl";
    GdsIcons["ICO_CARD_NEW"] = "ico-card-new";
    GdsIcons["ICO_CARD_PAYMENT_ACCEPTANCE_XL"] = "ico-card-payment-acceptance-xl";
    GdsIcons["ICO_CARD_PAYMENT_ACCEPTANCE"] = "ico-card-payment-acceptance";
    GdsIcons["ICO_CARD_REMOVE_XL"] = "ico-card-remove-xl";
    GdsIcons["ICO_CARD_REMOVE"] = "ico-card-remove";
    GdsIcons["ICO_CARD_REPLACEMENT_XL"] = "ico-card-replacement-xl";
    GdsIcons["ICO_CARD_REPLACEMENT"] = "ico-card-replacement";
    GdsIcons["ICO_CARD_SETTINGS_XL"] = "ico-card-settings-xl";
    GdsIcons["ICO_CARD_SETTINGS"] = "ico-card-settings";
    GdsIcons["ICO_CARD_TOPUP_XL"] = "ico-card-topup-xl";
    GdsIcons["ICO_CARD_TOPUP"] = "ico-card-topup";
    GdsIcons["ICO_CARDTAN_XL"] = "ico-cardtan-xl";
    GdsIcons["ICO_CARDTAN"] = "ico-cardtan";
    GdsIcons["ICO_CARET_DOWN_XL"] = "ico-caret-down-xl";
    GdsIcons["ICO_CARET_DOWN"] = "ico-caret-down";
    GdsIcons["ICO_CARET_LEFT_XL"] = "ico-caret-left-xl";
    GdsIcons["ICO_CARET_LEFT"] = "ico-caret-left";
    GdsIcons["ICO_CARET_RIGHT_XL"] = "ico-caret-right-xl";
    GdsIcons["ICO_CARET_RIGHT"] = "ico-caret-right";
    GdsIcons["ICO_CARET_UP_XL"] = "ico-caret-up-xl";
    GdsIcons["ICO_CARET_UP"] = "ico-caret-up";
    GdsIcons["ICO_CART_XL"] = "ico-cart-xl";
    GdsIcons["ICO_CART"] = "ico-cart";
    GdsIcons["ICO_CASHBACK_ACTIVATE_XL"] = "ico-cashback-activate-xl";
    GdsIcons["ICO_CASHBACK_ACTIVATE"] = "ico-cashback-activate";
    GdsIcons["ICO_CASHBACK_PAY_XL"] = "ico-cashback-pay-xl";
    GdsIcons["ICO_CASHBACK_PAY"] = "ico-cashback-pay";
    GdsIcons["ICO_CASHBACK_RECEIVE_XL"] = "ico-cashback-receive-xl";
    GdsIcons["ICO_CASHBACK_RECEIVE"] = "ico-cashback-receive";
    GdsIcons["ICO_CASHBACK_XL"] = "ico-cashback-xl";
    GdsIcons["ICO_CASHBACK"] = "ico-cashback";
    GdsIcons["ICO_CHARITY_XL"] = "ico-charity-xl";
    GdsIcons["ICO_CHARITY"] = "ico-charity";
    GdsIcons["ICO_CHART_HORIZONTAL_XL"] = "ico-chart-horizontal-xl";
    GdsIcons["ICO_CHART_HORIZONTAL"] = "ico-chart-horizontal";
    GdsIcons["ICO_CHART_ROUND_XL"] = "ico-chart-round-xl";
    GdsIcons["ICO_CHART_ROUND"] = "ico-chart-round";
    GdsIcons["ICO_CHART_VERTICAL_XL"] = "ico-chart-vertical-xl";
    GdsIcons["ICO_CHART_VERTICAL"] = "ico-chart-vertical";
    GdsIcons["ICO_CHECKMARK_CIRCLE_XL"] = "ico-checkmark-circle-xl";
    GdsIcons["ICO_CHECKMARK_CIRCLE"] = "ico-checkmark-circle";
    GdsIcons["ICO_CHECKMARK_XL"] = "ico-checkmark-xl";
    GdsIcons["ICO_CHECKMARK"] = "ico-checkmark";
    GdsIcons["ICO_CLOCK_XL"] = "ico-clock-xl";
    GdsIcons["ICO_CLOCK"] = "ico-clock";
    GdsIcons["ICO_CLOSED_XL"] = "ico-closed-xl";
    GdsIcons["ICO_CLOSED"] = "ico-closed";
    GdsIcons["ICO_COMMENT_IMPORTANT_XL"] = "ico-comment-important-xl";
    GdsIcons["ICO_COMMENT_IMPORTANT"] = "ico-comment-important";
    GdsIcons["ICO_COMMENT_XL"] = "ico-comment-xl";
    GdsIcons["ICO_COMMENT"] = "ico-comment";
    GdsIcons["ICO_COMMENTS_XL"] = "ico-comments-xl";
    GdsIcons["ICO_COMMENTS"] = "ico-comments";
    GdsIcons["ICO_COMPUTER_1_XL"] = "ico-computer-1-xl";
    GdsIcons["ICO_COMPUTER_1"] = "ico-computer-1";
    GdsIcons["ICO_COMPUTER_2_XL"] = "ico-computer-2-xl";
    GdsIcons["ICO_COMPUTER_2"] = "ico-computer-2";
    GdsIcons["ICO_CONSEQ_XL"] = "ico-conseq-xl";
    GdsIcons["ICO_CONSEQ"] = "ico-conseq";
    GdsIcons["ICO_CONTACTLESS_XL"] = "ico-contactless-xl";
    GdsIcons["ICO_CONTACTLESS"] = "ico-contactless";
    GdsIcons["ICO_COOKIE_XL"] = "ico-cookie-xl";
    GdsIcons["ICO_COOKIE"] = "ico-cookie";
    GdsIcons["ICO_COPY_XL"] = "ico-copy-xl";
    GdsIcons["ICO_COPY"] = "ico-copy";
    GdsIcons["ICO_CREDITCARD_ADDITIONAL_XL"] = "ico-creditcard-additional-xl";
    GdsIcons["ICO_CREDITCARD_ADDITIONAL"] = "ico-creditcard-additional";
    GdsIcons["ICO_CURRENT_LOCATION_XL"] = "ico-current-location-xl";
    GdsIcons["ICO_CURRENT_LOCATION"] = "ico-current-location";
    GdsIcons["ICO_DEBITMOBILE_ANDROID_XL"] = "ico-debitmobile-android-xl";
    GdsIcons["ICO_DEBITMOBILE_ANDROID"] = "ico-debitmobile-android";
    GdsIcons["ICO_DEBITMOBILE_BAND_XL"] = "ico-debitmobile-band-xl";
    GdsIcons["ICO_DEBITMOBILE_BAND"] = "ico-debitmobile-band";
    GdsIcons["ICO_DEBITMOBILE_STICKER_XL"] = "ico-debitmobile-sticker-xl";
    GdsIcons["ICO_DEBITMOBILE_STICKER"] = "ico-debitmobile-sticker";
    GdsIcons["ICO_DELETE_XL"] = "ico-delete-xl";
    GdsIcons["ICO_DELETE"] = "ico-delete";
    GdsIcons["ICO_DEVICES_XL"] = "ico-devices-xl";
    GdsIcons["ICO_DEVICES"] = "ico-devices";
    GdsIcons["ICO_DINERSCARD_XL"] = "ico-dinerscard-xl";
    GdsIcons["ICO_DINERSCARD"] = "ico-dinerscard";
    GdsIcons["ICO_DIRECT_DEBIT_INCOMING_XL"] = "ico-direct-debit-incoming-xl";
    GdsIcons["ICO_DIRECT_DEBIT_INCOMING"] = "ico-direct-debit-incoming";
    GdsIcons["ICO_DIRECT_DEBIT_OUTGOING_XL"] = "ico-direct-debit-outgoing-xl";
    GdsIcons["ICO_DIRECT_DEBIT_OUTGOING"] = "ico-direct-debit-outgoing";
    GdsIcons["ICO_DIRECT_DEBIT_REFUSED_XL"] = "ico-direct-debit-refused-xl";
    GdsIcons["ICO_DIRECT_DEBIT_REFUSED"] = "ico-direct-debit-refused";
    GdsIcons["ICO_DIRECT_DEBIT_SIPO_XL"] = "ico-direct-debit-sipo-xl";
    GdsIcons["ICO_DIRECT_DEBIT_SIPO"] = "ico-direct-debit-sipo";
    GdsIcons["ICO_DIRECT_DEBIT_XL"] = "ico-direct-debit-xl";
    GdsIcons["ICO_DIRECT_DEBIT"] = "ico-direct-debit";
    GdsIcons["ICO_DIRECTIONS_XL"] = "ico-directions-xl";
    GdsIcons["ICO_DIRECTIONS"] = "ico-directions";
    GdsIcons["ICO_DOT_LARGE_XL"] = "ico-dot-large-xl";
    GdsIcons["ICO_DOT_LARGE"] = "ico-dot-large";
    GdsIcons["ICO_DRAG_DROP_XL"] = "ico-drag-drop-xl";
    GdsIcons["ICO_DRAG_DROP"] = "ico-drag-drop";
    GdsIcons["ICO_DRAG_ITEM_XL"] = "ico-drag-item-xl";
    GdsIcons["ICO_DRAG_ITEM"] = "ico-drag-item";
    GdsIcons["ICO_E_MAIL_XL"] = "ico-e-mail-xl";
    GdsIcons["ICO_E_MAIL"] = "ico-e-mail";
    GdsIcons["ICO_EDIT_XL"] = "ico-edit-xl";
    GdsIcons["ICO_EDIT"] = "ico-edit";
    GdsIcons["ICO_ELECTRICITY_XL"] = "ico-electricity-xl";
    GdsIcons["ICO_ELECTRICITY"] = "ico-electricity";
    GdsIcons["ICO_EMOJI_ANGRY_XL"] = "ico-emoji-angry-xl";
    GdsIcons["ICO_EMOJI_ANGRY"] = "ico-emoji-angry";
    GdsIcons["ICO_EMOJI_HAPPY_XL"] = "ico-emoji-happy-xl";
    GdsIcons["ICO_EMOJI_HAPPY"] = "ico-emoji-happy";
    GdsIcons["ICO_EMOJI_JOY_XL"] = "ico-emoji-joy-xl";
    GdsIcons["ICO_EMOJI_JOY"] = "ico-emoji-joy";
    GdsIcons["ICO_EMOJI_OKAY_XL"] = "ico-emoji-okay-xl";
    GdsIcons["ICO_EMOJI_OKAY"] = "ico-emoji-okay";
    GdsIcons["ICO_EMOJI_SAD_XL"] = "ico-emoji-sad-xl";
    GdsIcons["ICO_EMOJI_SAD"] = "ico-emoji-sad";
    GdsIcons["ICO_EMPTY_STATE_GENERIC_XL"] = "ico-empty-state-generic-xl";
    GdsIcons["ICO_EMPTY_STATE_GENERIC"] = "ico-empty-state-generic";
    GdsIcons["ICO_ERROR_CIRCLE_XL"] = "ico-error-circle-xl";
    GdsIcons["ICO_ERROR_CIRCLE"] = "ico-error-circle";
    GdsIcons["ICO_ERROR_XL"] = "ico-error-xl";
    GdsIcons["ICO_ERROR"] = "ico-error";
    GdsIcons["ICO_ERSTE_XL"] = "ico-erste-xl";
    GdsIcons["ICO_ERSTE"] = "ico-erste";
    GdsIcons["ICO_EURO_CONVERT_XL"] = "ico-euro-convert-xl";
    GdsIcons["ICO_EURO_CONVERT"] = "ico-euro-convert";
    GdsIcons["ICO_EURO_XL"] = "ico-euro-xl";
    GdsIcons["ICO_EURO"] = "ico-euro";
    GdsIcons["ICO_FACE_ID_XL"] = "ico-face-id-xl";
    GdsIcons["ICO_FACE_ID"] = "ico-face-id";
    GdsIcons["ICO_FACEBOOK_XL"] = "ico-facebook-xl";
    GdsIcons["ICO_FACEBOOK"] = "ico-facebook";
    GdsIcons["ICO_FEEDBACK_XL"] = "ico-feedback-xl";
    GdsIcons["ICO_FEEDBACK"] = "ico-feedback";
    GdsIcons["ICO_FILE_DOWNLOAD_XL"] = "ico-file-download-xl";
    GdsIcons["ICO_FILE_DOWNLOAD"] = "ico-file-download";
    GdsIcons["ICO_FILE_LOCKED_XL"] = "ico-file-locked-xl";
    GdsIcons["ICO_FILE_LOCKED"] = "ico-file-locked";
    GdsIcons["ICO_FILE_UPLOAD_XL"] = "ico-file-upload-xl";
    GdsIcons["ICO_FILE_UPLOAD"] = "ico-file-upload";
    GdsIcons["ICO_FILE_XL"] = "ico-file-xl";
    GdsIcons["ICO_FILE"] = "ico-file";
    GdsIcons["ICO_FILTER_XL"] = "ico-filter-xl";
    GdsIcons["ICO_FILTER"] = "ico-filter";
    GdsIcons["ICO_FINGERPRINT_XL"] = "ico-fingerprint-xl";
    GdsIcons["ICO_FINGERPRINT"] = "ico-fingerprint";
    GdsIcons["ICO_FIRE_XL"] = "ico-fire-xl";
    GdsIcons["ICO_FIRE"] = "ico-fire";
    GdsIcons["ICO_FIT_GOOD_FILL"] = "ico-fit-good-fill";
    GdsIcons["ICO_FIT_GOOD_OUTLINE"] = "ico-fit-good-outline";
    GdsIcons["ICO_FLASH_XL"] = "ico-flash-xl";
    GdsIcons["ICO_FLASH"] = "ico-flash";
    GdsIcons["ICO_FOLDER_CONTRACT_XL"] = "ico-folder-contract-xl";
    GdsIcons["ICO_FOLDER_CONTRACT"] = "ico-folder-contract";
    GdsIcons["ICO_FOLDER_DELETE_XL"] = "ico-folder-delete-xl";
    GdsIcons["ICO_FOLDER_DELETE"] = "ico-folder-delete";
    GdsIcons["ICO_FOLDER_IMPORT_XL"] = "ico-folder-import-xl";
    GdsIcons["ICO_FOLDER_IMPORT"] = "ico-folder-import";
    GdsIcons["ICO_FOLDER_INVOICE_XL"] = "ico-folder-invoice-xl";
    GdsIcons["ICO_FOLDER_INVOICE"] = "ico-folder-invoice";
    GdsIcons["ICO_FOLDER_NEW_XL"] = "ico-folder-new-xl";
    GdsIcons["ICO_FOLDER_NEW"] = "ico-folder-new";
    GdsIcons["ICO_FOLDER_PERSONAL_XL"] = "ico-folder-personal-xl";
    GdsIcons["ICO_FOLDER_PERSONAL"] = "ico-folder-personal";
    GdsIcons["ICO_FOLDER_PHOTOS_XL"] = "ico-folder-photos-xl";
    GdsIcons["ICO_FOLDER_PHOTOS"] = "ico-folder-photos";
    GdsIcons["ICO_FOLDER_STORAGE_XL"] = "ico-folder-storage-xl";
    GdsIcons["ICO_FOLDER_STORAGE"] = "ico-folder-storage";
    GdsIcons["ICO_FOLDER_XL"] = "ico-folder-xl";
    GdsIcons["ICO_FOLDER"] = "ico-folder";
    GdsIcons["ICO_FONT_XL"] = "ico-font-xl";
    GdsIcons["ICO_FONT"] = "ico-font";
    GdsIcons["ICO_FREEZE_XL"] = "ico-freeze-xl";
    GdsIcons["ICO_FREEZE"] = "ico-freeze";
    GdsIcons["ICO_FULLSCREEN_XL"] = "ico-fullscreen-xl";
    GdsIcons["ICO_FULLSCREEN"] = "ico-fullscreen";
    GdsIcons["ICO_GEO_CONTROL_XL"] = "ico-geo-control-xl";
    GdsIcons["ICO_GEO_CONTROL"] = "ico-geo-control";
    GdsIcons["ICO_GEORGE_LOGO_XL"] = "ico-george-logo-xl";
    GdsIcons["ICO_GEORGE_LOGO"] = "ico-george-logo";
    GdsIcons["ICO_GEU_SERVICE_B24_XL"] = "ico-geu-service-b24-xl";
    GdsIcons["ICO_GEU_SERVICE_B24"] = "ico-geu-service-b24";
    GdsIcons["ICO_GEU_SERVICE_BLUE_XL"] = "ico-geu-service-blue-xl";
    GdsIcons["ICO_GEU_SERVICE_BLUE"] = "ico-geu-service-blue";
    GdsIcons["ICO_GEU_SERVICE_MZF_XL"] = "ico-geu-service-mzf-xl";
    GdsIcons["ICO_GEU_SERVICE_MZF"] = "ico-geu-service-mzf";
    GdsIcons["ICO_GEU_SERVICE_PZD"] = "ico-geu-service-pzd";
    GdsIcons["ICO_GEU_SERVICE_S24_XL"] = "ico-geu-service-s24-xl";
    GdsIcons["ICO_GEU_SERVICE_S24"] = "ico-geu-service-s24";
    GdsIcons["ICO_GOLD_BARS_XL"] = "ico-gold-bars-xl";
    GdsIcons["ICO_GOLD_BARS"] = "ico-gold-bars";
    GdsIcons["ICO_GRIDCARD_XL"] = "ico-gridcard-xl";
    GdsIcons["ICO_GRIDCARD"] = "ico-gridcard";
    GdsIcons["ICO_GROUP_XL"] = "ico-group-xl";
    GdsIcons["ICO_GROUP"] = "ico-group";
    GdsIcons["ICO_HAND_COIN_XL"] = "ico-hand-coin-xl";
    GdsIcons["ICO_HAND_COIN"] = "ico-hand-coin";
    GdsIcons["ICO_HAND_COINS_XL"] = "ico-hand-coins-xl";
    GdsIcons["ICO_HAND_COINS"] = "ico-hand-coins";
    GdsIcons["ICO_HAND_CURSOR_XL"] = "ico-hand-cursor-xl";
    GdsIcons["ICO_HAND_CURSOR"] = "ico-hand-cursor";
    GdsIcons["ICO_HAND_WALLET_XL"] = "ico-hand-wallet-xl";
    GdsIcons["ICO_HAND_WALLET"] = "ico-hand-wallet";
    GdsIcons["ICO_HANDS_OUTLINE_XL"] = "ico-hands-outline-xl";
    GdsIcons["ICO_HANDS_OUTLINE"] = "ico-hands-outline";
    GdsIcons["ICO_HASHTAG"] = "ico-hashtag";
    GdsIcons["ICO_HELP_XL"] = "ico-help-xl";
    GdsIcons["ICO_HELP"] = "ico-help";
    GdsIcons["ICO_HELPDESK_XL"] = "ico-helpdesk-xl";
    GdsIcons["ICO_HILFREICH_XL"] = "ico-hilfreich-xl";
    GdsIcons["ICO_HILFREICH"] = "ico-hilfreich";
    GdsIcons["ICO_HOME_SECONDARY_XL"] = "ico-home-secondary-xl";
    GdsIcons["ICO_HOME_SECONDARY"] = "ico-home-secondary";
    GdsIcons["ICO_HOME_XL"] = "ico-home-xl";
    GdsIcons["ICO_HOME"] = "ico-home";
    GdsIcons["ICO_INFO_XL"] = "ico-info-xl";
    GdsIcons["ICO_INFO"] = "ico-info";
    GdsIcons["ICO_INSTAGRAM_XL"] = "ico-instagram-xl";
    GdsIcons["ICO_INSTAGRAM"] = "ico-instagram";
    GdsIcons["ICO_INSURANCE_XL"] = "ico-insurance-xl";
    GdsIcons["ICO_INSURANCE"] = "ico-insurance";
    GdsIcons["ICO_INVITE_OTHERS_XL"] = "ico-invite-others-xl";
    GdsIcons["ICO_INVITE_OTHERS"] = "ico-invite-others";
    GdsIcons["ICO_INVOICE_DIGITAL_XL"] = "ico-invoice-digital-xl";
    GdsIcons["ICO_INVOICE_DIGITAL"] = "ico-invoice-digital";
    GdsIcons["ICO_INVOICE_POSTAL_XL"] = "ico-invoice-postal-xl";
    GdsIcons["ICO_INVOICE_POSTAL"] = "ico-invoice-postal";
    GdsIcons["ICO_INVOICE_XL"] = "ico-invoice-xl";
    GdsIcons["ICO_KEY_XL"] = "ico-key-xl";
    GdsIcons["ICO_KEY"] = "ico-key";
    GdsIcons["ICO_KEYBOARD_XL"] = "ico-keyboard-xl";
    GdsIcons["ICO_KEYBOARD"] = "ico-keyboard";
    GdsIcons["ICO_KIDS_OUTLINE_XL"] = "ico-kids-outline-xl";
    GdsIcons["ICO_KIDS_OUTLINE"] = "ico-kids-outline";
    GdsIcons["ICO_LEAF_XL"] = "ico-leaf-xl";
    GdsIcons["ICO_LEAF"] = "ico-leaf";
    GdsIcons["ICO_LEAKAGE_XL"] = "ico-leakage-xl";
    GdsIcons["ICO_LEAKAGE"] = "ico-leakage";
    GdsIcons["ICO_LIABILITY_INSURANCE_XL"] = "ico-liability-insurance-xl";
    GdsIcons["ICO_LIABILITY_INSURANCE"] = "ico-liability-insurance";
    GdsIcons["ICO_LIABILITY_XL"] = "ico-liability-xl";
    GdsIcons["ICO_LIABILITY"] = "ico-liability";
    GdsIcons["ICO_LIGHTBULB_XL"] = "ico-lightbulb-xl";
    GdsIcons["ICO_LIGHTBULB"] = "ico-lightbulb";
    GdsIcons["ICO_LINK_XL"] = "ico-link-xl";
    GdsIcons["ICO_LINK"] = "ico-link";
    GdsIcons["ICO_LINKEDIN_XL"] = "ico-linkedin-xl";
    GdsIcons["ICO_LINKEDIN"] = "ico-linkedin";
    GdsIcons["ICO_LIST_XL"] = "ico-list-xl";
    GdsIcons["ICO_LIST"] = "ico-list";
    GdsIcons["ICO_LOAN_RECONSTRUCTION_XL"] = "ico-loan-reconstruction-xl";
    GdsIcons["ICO_LOAN_RECONSTRUCITON"] = "ico-loan-reconstruction";
    GdsIcons["ICO_LOCATION_XL"] = "ico-location-xl";
    GdsIcons["ICO_LOCATION"] = "ico-location";
    GdsIcons["ICO_LOCK_CLOSED_XL"] = "ico-lock-closed-xl";
    GdsIcons["ICO_LOCK_CLOSED"] = "ico-lock-closed";
    GdsIcons["ICO_LOCK_OPEN_XL"] = "ico-lock-open-xl";
    GdsIcons["ICO_LOCK_OPEN"] = "ico-lock-open";
    GdsIcons["ICO_LOGOUT_XL"] = "ico-logout-xl";
    GdsIcons["ICO_LOGOUT"] = "ico-logout";
    GdsIcons["ICO_MAGIC_XL"] = "ico-magic-xl";
    GdsIcons["ICO_MAGIC"] = "ico-magic";
    GdsIcons["ICO_MAIL_XL"] = "ico-mail-xl";
    GdsIcons["ICO_MAIL"] = "ico-mail";
    GdsIcons["ICO_MARKETING_INFO_XL"] = "ico-marketing-info-xl";
    GdsIcons["ICO_MARKETING_INFO"] = "ico-marketing-info";
    GdsIcons["ICO_MASTERCARD_XL"] = "ico-mastercard-xl";
    GdsIcons["ICO_MASTERCARD"] = "ico-mastercard";
    GdsIcons["ICO_MEDIA_PAUSE_XL"] = "ico-media-pause-xl";
    GdsIcons["ICO_MEDIA_PAUSE"] = "ico-media-pause";
    GdsIcons["ICO_MEDIA_PLAY_XL"] = "ico-media-play-xl";
    GdsIcons["ICO_MEDIA_PLAY"] = "ico-media-play";
    GdsIcons["ICO_MEDIA_STOP_XL"] = "ico-media-stop-xl";
    GdsIcons["ICO_MEDIA_STOP"] = "ico-media-stop";
    GdsIcons["ICO_MENU_XL"] = "ico-menu-xl";
    GdsIcons["ICO_MENU"] = "ico-menu";
    GdsIcons["ICO_MINUS_XL"] = "ico-minus-xl";
    GdsIcons["ICO_MINUS"] = "ico-minus";
    GdsIcons["ICO_MOBILE_NFC_PAYMENT_XL"] = "ico-mobile-nfc-payment-xl";
    GdsIcons["ICO_MOBILE_NFC_PAYMENT"] = "ico-mobile-nfc-payment";
    GdsIcons["ICO_MOBILE_TOP_UP_XL"] = "ico-mobile-top-up-xl";
    GdsIcons["ICO_MOBILE_TOP_UP"] = "ico-mobile-top-up";
    GdsIcons["ICO_MONEY_XL"] = "ico-money-xl";
    GdsIcons["ICO_MONEY"] = "ico-money";
    GdsIcons["ICO_MORE_HORIZONTAL_XL"] = "ico-more-horizontal-xl";
    GdsIcons["ICO_MORE_HORIZONTAL"] = "ico-more-horizontal";
    GdsIcons["ICO_MORE_IOS_XL"] = "ico-more-ios-xl";
    GdsIcons["ICO_MORE_IOS"] = "ico-more-ios";
    GdsIcons["ICO_MORE_VERTICAL_XL"] = "ico-more-vertical-xl";
    GdsIcons["ICO_MORE_VERTICAL"] = "ico-more-vertical";
    GdsIcons["ICO_MULTIBANKING_SYNC_XL"] = "ico-multibanking-sync-xl";
    GdsIcons["ICO_MULTIBANKING_SYNC"] = "ico-multibanking-sync";
    GdsIcons["ICO_NATURAL_DISASTER_XL"] = "ico-natural-disaster-xl";
    GdsIcons["ICO_NATURAL_DISASTER"] = "ico-natural-disaster";
    GdsIcons["ICO_NEW_XL"] = "ico-new-xl";
    GdsIcons["ICO_NEW"] = "ico-new";
    GdsIcons["ICO_NEWSLETTER_XL"] = "ico-newsletter-xl";
    GdsIcons["ICO_NEWSLETTER"] = "ico-newsletter";
    GdsIcons["ICO_NOTIFICATION_XL"] = "ico-notification-xl";
    GdsIcons["ICO_NOTIFICATION"] = "ico-notification";
    GdsIcons["ICO_OFFER_XL"] = "ico-offer-xl";
    GdsIcons["ICO_OFFER"] = "ico-offer";
    GdsIcons["ICO_PALETTE_XL"] = "ico-palette-xl";
    GdsIcons["ICO_PALETTE"] = "ico-palette";
    GdsIcons["ICO_PARACHUTE_XL"] = "ico-parachute-xl";
    GdsIcons["ICO_PARACHUTE"] = "ico-parachute";
    GdsIcons["ICO_PATTERN_XL"] = "ico-pattern-xl";
    GdsIcons["ICO_PATTERN"] = "ico-pattern";
    GdsIcons["ICO_PAYME_XL"] = "ico-payme-xl";
    GdsIcons["ICO_PAYME"] = "ico-payme";
    GdsIcons["ICO_PAYMENT_FULL_XL"] = "ico-payment-full-xl";
    GdsIcons["ICO_PAYMENT_FULL"] = "ico-payment-full";
    GdsIcons["ICO_PAYMENT_PARTIAL_XL"] = "ico-payment-partial-xl";
    GdsIcons["ICO_PAYMENT_PARTIAL"] = "ico-payment-partial";
    GdsIcons["ICO_PAYMENT_SLIP_XL"] = "ico-payment-slip-xl";
    GdsIcons["ICO_PAYMENT_SLIP"] = "ico-payment-slip";
    GdsIcons["ICO_PENNIES_ON_CLICK_XL"] = "ico-pennies-on-click-xl";
    GdsIcons["ICO_PENNIES_ON_CLICK"] = "ico-pennies-on-click";
    GdsIcons["ICO_PENSION_SAVINGS_XL"] = "ico-pension-savings-xl";
    GdsIcons["ICO_PENSION_SAVINGS"] = "ico-pension-savings";
    GdsIcons["ICO_PFM_ALIMONEY_XL"] = "ico-pfm-alimoney-xl";
    GdsIcons["ICO_PFM_ALIMONEY"] = "ico-pfm-alimoney";
    GdsIcons["ICO_PFM_CAR_XL"] = "ico-pfm-car-xl";
    GdsIcons["ICO_PFM_CAR"] = "ico-pfm-car";
    GdsIcons["ICO_PFM_CLOTHING_XL"] = "ico-pfm-clothing-xl";
    GdsIcons["ICO_PFM_CLOTHING"] = "ico-pfm-clothing";
    GdsIcons["ICO_PFM_EDUCATION_XL"] = "ico-pfm-education-xl";
    GdsIcons["ICO_PFM_EDUCATION"] = "ico-pfm-education";
    GdsIcons["ICO_PFM_FEES_XL"] = "ico-pfm-fees-xl";
    GdsIcons["ICO_PFM_FEES"] = "ico-pfm-fees";
    GdsIcons["ICO_PFM_FOOD_XL"] = "ico-pfm-food-xl";
    GdsIcons["ICO_PFM_FOOD"] = "ico-pfm-food";
    GdsIcons["ICO_PFM_HEALTH_XL"] = "ico-pfm-health-xl";
    GdsIcons["ICO_PFM_HEALTH"] = "ico-pfm-health";
    GdsIcons["ICO_PFM_HOBBY_XL"] = "ico-pfm-hobby-xl";
    GdsIcons["ICO_PFM_HOBBY"] = "ico-pfm-hobby";
    GdsIcons["ICO_PFM_HOLIDAYS_XL"] = "ico-pfm-holidays-xl";
    GdsIcons["ICO_PFM_HOLIDAYS"] = "ico-pfm-holidays";
    GdsIcons["ICO_PFM_LIVING_XL"] = "ico-pfm-living-xl";
    GdsIcons["ICO_PFM_LIVING"] = "ico-pfm-living";
    GdsIcons["ICO_PFM_MEDIA_XL"] = "ico-pfm-media-xl";
    GdsIcons["ICO_PFM_MEDIA"] = "ico-pfm-media";
    GdsIcons["ICO_PFM_ONLINE_XL"] = "ico-pfm-online-xl";
    GdsIcons["ICO_PFM_ONLINE"] = "ico-pfm-online";
    GdsIcons["ICO_PFM_OTHER_INCOMING_XL"] = "ico-pfm-other-incoming-xl";
    GdsIcons["ICO_PFM_OTHER_INCOMING"] = "ico-pfm-other-incoming";
    GdsIcons["ICO_PFM_OTHER_OUTGOING_XL"] = "ico-pfm-other-outgoing-xl";
    GdsIcons["ICO_PFM_OTHER_OUTGOING"] = "ico-pfm-other-outgoing";
    GdsIcons["ICO_PFM_PUBLIC_TRANSPORT_XL"] = "ico-pfm-public-transport-xl";
    GdsIcons["ICO_PFM_PUBLIC_TRANSPORT"] = "ico-pfm-public-transport";
    GdsIcons["ICO_PFM_TAXES_XL"] = "ico-pfm-taxes-xl";
    GdsIcons["ICO_PFM_TAXES"] = "ico-pfm-taxes";
    GdsIcons["ICO_PFM_WITHDRAWAL_XL"] = "ico-pfm-withdrawal-xl";
    GdsIcons["ICO_PFM_WITHDRAWAL"] = "ico-pfm-withdrawal";
    GdsIcons["ICO_PHONE_HOTLINE_XL"] = "ico-phone-hotline-xl";
    GdsIcons["ICO_PHONE_HOTLINE"] = "ico-phone-hotline";
    GdsIcons["ICO_PHONE_MOBILE_XL"] = "ico-phone-mobile-xl";
    GdsIcons["ICO_PHONE_MOBILE"] = "ico-phone-mobile";
    GdsIcons["ICO_PHOTO_XL"] = "ico-photo-xl";
    GdsIcons["ICO_PHOTO"] = "ico-photo";
    GdsIcons["ICO_PIN_XL"] = "ico-pin-xl";
    GdsIcons["ICO_PIN"] = "ico-pin";
    GdsIcons["ICO_PLACEHOLDER_XL"] = "ico-placeholder-xl";
    GdsIcons["ICO_PLACEHOLDER"] = "ico-placeholder";
    GdsIcons["ICO_PLUGIN_BUDGETS_XL"] = "ico-plugin-budgets-xl";
    GdsIcons["ICO_PLUGIN_BUDGETS"] = "ico-plugin-budgets";
    GdsIcons["ICO_PLUGIN_FILETRANSFER_XL"] = "ico-plugin-filetransfer-xl";
    GdsIcons["ICO_PLUGIN_FILETRANSFER"] = "ico-plugin-filetransfer";
    GdsIcons["ICO_PLUGIN_GIFTCARD_XL"] = "ico-plugin-giftcard-xl";
    GdsIcons["ICO_PLUGIN_GIFTCARD"] = "ico-plugin-giftcard";
    GdsIcons["ICO_PLUGIN_MONEYBACK_XL"] = "ico-plugin-moneyback-xl";
    GdsIcons["ICO_PLUGIN_MONEYBACK"] = "ico-plugin-moneyback";
    GdsIcons["ICO_PLUGIN_MULTIBANKING_XL"] = "ico-plugin-multibanking-xl";
    GdsIcons["ICO_PLUGIN_MULTIBANKING"] = "ico-plugin-multibanking";
    GdsIcons["ICO_PLUGIN_PRO_XL"] = "ico-plugin-pro-xl";
    GdsIcons["ICO_PLUGIN_PRO"] = "ico-plugin-pro";
    GdsIcons["ICO_PLUGIN_REMEMBER_TO_PAY_XL"] = "ico-plugin-remember-to-pay-xl";
    GdsIcons["ICO_PLUGIN_REMEMBER_TO_PAY"] = "ico-plugin-remember-to-pay";
    GdsIcons["ICO_PLUGIN_SAFE_XL"] = "ico-plugin-safe-xl";
    GdsIcons["ICO_PLUGIN_SAFE"] = "ico-plugin-safe";
    GdsIcons["ICO_PLUGIN_SNAPSHOT_XL"] = "ico-plugin-snapshot-xl";
    GdsIcons["ICO_PLUGIN_SNAPSHOT"] = "ico-plugin-snapshot";
    GdsIcons["ICO_PLUGIN_WHATIF_XL"] = "ico-plugin-whatif-xl";
    GdsIcons["ICO_PLUGIN_WHATIF"] = "ico-plugin-whatif";
    GdsIcons["ICO_PLUS_XL"] = "ico-plus-xl";
    GdsIcons["ICO_PLUS"] = "ico-plus";
    GdsIcons["ICO_PORTFOLIO_XL"] = "ico-portfolio-xl";
    GdsIcons["ICO_PORTFOLIO"] = "ico-portfolio";
    GdsIcons["ICO_PRINT_XL"] = "ico-print-xl";
    GdsIcons["ICO_PRINT"] = "ico-print";
    GdsIcons["ICO_PRO_DASHBOARD_ACTIVE_XL"] = "ico-pro-dashboard-active-xl";
    GdsIcons["ICO_PRO_DASHBOARD_ACTIVE"] = "ico-pro-dashboard-active";
    GdsIcons["ICO_PRO_DASHBOARD_DEFAULT_XL"] = "ico-pro-dashboard-default-xl";
    GdsIcons["ICO_PRO_DASHBOARD_DEFAULT"] = "ico-pro-dashboard-default";
    GdsIcons["ICO_PRO_INVOICES_ACTIVE_XL"] = "ico-pro-invoices-active-xl";
    GdsIcons["ICO_PRO_INVOICES_ACTIVE"] = "ico-pro-invoices-active";
    GdsIcons["ICO_PRO_INVOICES_DEFAULT_XL"] = "ico-pro-invoices-default-xl";
    GdsIcons["ICO_PRO_INVOICES_DEFAULT"] = "ico-pro-invoices-default";
    GdsIcons["ICO_PRO_PROFILE_ACTIVE_XL"] = "ico-pro-profile-active-xl";
    GdsIcons["ICO_PRO_PROFILE_ACTIVE"] = "ico-pro-profile-active";
    GdsIcons["ICO_PRO_PROFILE_DEFAULT_XL"] = "ico-pro-profile-default-xl";
    GdsIcons["ICO_PRO_PROFILE_DEFAULT"] = "ico-pro-profile-default";
    GdsIcons["ICO_PRODUCT_SORTING_XL"] = "ico-product-sorting-xl";
    GdsIcons["ICO_PRODUCT_SORTING"] = "ico-product-sorting";
    GdsIcons["ICO_PRODUCTS_XL"] = "ico-products-xl";
    GdsIcons["ICO_PRODUCTS"] = "ico-products";
    GdsIcons["ICO_QR_CODE_XL"] = "ico-qr-code-xl";
    GdsIcons["ICO_QR_CODE"] = "ico-qr-code";
    GdsIcons["ICO_RAINBOW_XL"] = "ico-rainbow-xl";
    GdsIcons["ICO_RAINBOW"] = "ico-rainbow";
    GdsIcons["ICO_REDO_XL"] = "ico-redo-xl";
    GdsIcons["ICO_REDO"] = "ico-redo";
    GdsIcons["ICO_RELOAD_XL"] = "ico-reload-xl";
    GdsIcons["ICO_RELOAD"] = "ico-reload";
    GdsIcons["ICO_REPLY_XL"] = "ico-reply-xl";
    GdsIcons["ICO_REPLY"] = "ico-reply";
    GdsIcons["ICO_REWARD_BADGE_XL"] = "ico-reward-badge-xl";
    GdsIcons["ICO_REWARD_BADGE"] = "ico-reward-badge";
    GdsIcons["ICO_ROBBERY_XL"] = "ico-robbery-xl";
    GdsIcons["ICO_ROBBERY"] = "ico-robbery";
    GdsIcons["ICO_ROUNDING_HILFREICH_XL"] = "ico-rounding-hilfreich-xl";
    GdsIcons["ICO_ROUNDING_HILFREICH"] = "ico-rounding-hilfreich";
    GdsIcons["ICO_S_ID_APP_XL"] = "ico-s-id-app-xl";
    GdsIcons["ICO_S_ID_APP"] = "ico-s-id-app";
    GdsIcons["ICO_SAVINGS_XL"] = "ico-savings-xl";
    GdsIcons["ICO_SAVINGS"] = "ico-savings";
    GdsIcons["ICO_SEARCH_XL"] = "ico-search-xl";
    GdsIcons["ICO_SEARCH"] = "ico-search";
    GdsIcons["ICO_SECURITY_GOOD_XL"] = "ico-security-good-xl";
    GdsIcons["ICO_SECURITY_GOOD"] = "ico-security-good";
    GdsIcons["ICO_SECURITY_USER_XL"] = "ico-security-user-xl";
    GdsIcons["ICO_SECURITY_USER"] = "ico-security-user";
    GdsIcons["ICO_SECURITY_WARNING_XL"] = "ico-security-warning-xl";
    GdsIcons["ICO_SECURITY_WARNING"] = "ico-security-warning";
    GdsIcons["ICO_SELECTION_XL"] = "ico-selection-xl";
    GdsIcons["ICO_SELECTION"] = "ico-selection";
    GdsIcons["ICO_SEND_XL"] = "ico-send-xl";
    GdsIcons["ICO_SEND"] = "ico-send";
    GdsIcons["ICO_SETTINGS_XL"] = "ico-settings-xl";
    GdsIcons["ICO_SETTINGS"] = "ico-settings";
    GdsIcons["ICO_SG_ELECTRONICS_XL"] = "ico-sg-electronics-xl";
    GdsIcons["ICO_SG_ELECTRONICS"] = "ico-sg-electronics";
    GdsIcons["ICO_SG_FURNITURE_XL"] = "ico-sg-furniture-xl";
    GdsIcons["ICO_SG_FURNITURE"] = "ico-sg-furniture";
    GdsIcons["ICO_SG_GIFT_AND_PARTIES_XL"] = "ico-sg-gift-and-parties-xl";
    GdsIcons["ICO_SG_GIFT_AND_PARTIES"] = "ico-sg-gift-and-parties";
    GdsIcons["ICO_SG_SPORTS_EQUIPMENT_XL"] = "ico-sg-sports-equipment-xl";
    GdsIcons["ICO_SG_SPORTS_EQUIPMENT"] = "ico-sg-sports-equipment";
    GdsIcons["ICO_SG_WHITE_GOODS_XL"] = "ico-sg-white-goods-xl";
    GdsIcons["ICO_SG_WHITE_GOODS"] = "ico-sg-white-goods";
    GdsIcons["ICO_SHARE_ANDROID_XL"] = "ico-share-android-xl";
    GdsIcons["ICO_SHARE_ANDROID"] = "ico-share-android";
    GdsIcons["ICO_SHARE_IOS_XL"] = "ico-share-ios-xl";
    GdsIcons["ICO_SHARE_IOS"] = "ico-share-ios";
    GdsIcons["ICO_SHARE_XL"] = "ico-share-xl";
    GdsIcons["ICO_SHARE"] = "ico-share";
    GdsIcons["ICO_SHOPPING_XL"] = "ico-shopping-xl";
    GdsIcons["ICO_SHOPPING"] = "ico-shopping";
    GdsIcons["ICO_SHOW_OFF_XL"] = "ico-show-off-xl";
    GdsIcons["ICO_SHOW_OFF"] = "ico-show-off";
    GdsIcons["ICO_SHOW_ON_XL"] = "ico-show-on-xl";
    GdsIcons["ICO_SHOW_ON"] = "ico-show-on";
    GdsIcons["ICO_SIDENTITY_LOGO_XL"] = "ico-sidentity-logo-xl";
    GdsIcons["ICO_SIDENTITY_LOGO"] = "ico-sidentity-logo";
    GdsIcons["ICO_SIGN_XL"] = "ico-sign-xl";
    GdsIcons["ICO_SIGN"] = "ico-sign";
    GdsIcons["ICO_SMS_CODE_XL"] = "ico-sms-code-xl";
    GdsIcons["ICO_SMS_CODE"] = "ico-sms-code";
    GdsIcons["ICO_SPARKASSE_XL"] = "ico-sparkasse-xl";
    GdsIcons["ICO_SPARKASSE"] = "ico-sparkasse";
    GdsIcons["ICO_STANDING_ORDER_XL"] = "ico-standing-order-xl";
    GdsIcons["ICO_STANDING_ORDER"] = "ico-standing-order";
    GdsIcons["ICO_STAR_FILLED_XL"] = "ico-star-filled-xl";
    GdsIcons["ICO_STAR_FILLED"] = "ico-star-filled";
    GdsIcons["ICO_STAR_XL"] = "ico-star-xl";
    GdsIcons["ICO_STAR"] = "ico-star";
    GdsIcons["ICO_STICKER_INFO_XL"] = "ico-sticker-info-xl";
    GdsIcons["ICO_STICKER_INFO"] = "ico-sticker-info";
    GdsIcons["ICO_STORE_XL"] = "ico-store-xl";
    GdsIcons["ICO_STORE"] = "ico-store";
    GdsIcons["ICO_SUM_XL"] = "ico-sum-xl";
    GdsIcons["ICO_SUM"] = "ico-sum";
    GdsIcons["ICO_SWEEP_ORDER_XL"] = "ico-sweep-order-xl";
    GdsIcons["ICO_SWEEP_ORDER"] = "ico-sweep-order";
    GdsIcons["ICO_TAG_XL"] = "ico-tag-xl";
    GdsIcons["ICO_TAG"] = "ico-tag";
    GdsIcons["ICO_TEMPLATE_PENSION_XL"] = "ico-template-pension-xl";
    GdsIcons["ICO_TEMPLATE_PENSION"] = "ico-template-pension";
    GdsIcons["ICO_TEMPLATE_SALARY_XL"] = "ico-template-salary-xl";
    GdsIcons["ICO_TEMPLATE_SALARY"] = "ico-template-salary";
    GdsIcons["ICO_TEMPLATE_XL"] = "ico-template-xl";
    GdsIcons["ICO_TEMPLATE"] = "ico-template";
    GdsIcons["ICO_TEXT_XL"] = "ico-text-xl";
    GdsIcons["ICO_TEXT"] = "ico-text";
    GdsIcons["ICO_THUMB_DOWN_XL"] = "ico-thumb-down-xl";
    GdsIcons["ICO_THUMB_DOWN"] = "ico-thumb-down";
    GdsIcons["ICO_THUMB_UP_XL"] = "ico-thumb-up-xl";
    GdsIcons["ICO_THUMB_UP"] = "ico-thumb-up";
    GdsIcons["ICO_TRIANGLE_DOUBLE_XL"] = "ico-triangle-double-xl";
    GdsIcons["ICO_TRIANGLE_DOUBLE"] = "ico-triangle-double";
    GdsIcons["ICO_TUTORIAL_XL"] = "ico-tutorial-xl";
    GdsIcons["ICO_TUTORIAL"] = "ico-tutorial";
    GdsIcons["ICO_TWITTER_XL"] = "ico-twitter-xl";
    GdsIcons["ICO_TWITTER"] = "ico-twitter";
    GdsIcons["ICO_UNREAD_XL"] = "ico-unread-xl";
    GdsIcons["ICO_UNREAD"] = "ico-unread";
    GdsIcons["ICO_USER_CHECK_XL"] = "ico-user-check-xl";
    GdsIcons["ICO_USER_CHECK"] = "ico-user-check";
    GdsIcons["ICO_USER_EDIT_XL"] = "ico-user-edit-xl";
    GdsIcons["ICO_USER_EDIT"] = "ico-user-edit";
    GdsIcons["ICO_USER_XL"] = "ico-user-xl";
    GdsIcons["ICO_USER"] = "ico-user";
    GdsIcons["ICO_VECTOR_XL"] = "ico-Vector-xl";
    GdsIcons["ICO_VECTOR"] = "ico-Vector";
    GdsIcons["ICO_VIDEO_CALL_XL"] = "ico-video-call-xl";
    GdsIcons["ICO_VIDEO_CALL"] = "ico-video-call";
    GdsIcons["ICO_VISACARD_XL"] = "ico-visacard-xl";
    GdsIcons["ICO_VISACARD"] = "ico-visacard";
    GdsIcons["ICO_VOLUME_OFF_XL"] = "ico-volume-off-xl";
    GdsIcons["ICO_VOLUME_OFF"] = "ico-volume-off";
    GdsIcons["ICO_VOLUME_UP_XL"] = "ico-volume-up-xl";
    GdsIcons["ICO_VOLUME_UP"] = "ico-volume-up";
    GdsIcons["ICO_WALLET_XL"] = "ico-wallet-xl";
    GdsIcons["ICO_WALLET"] = "ico-wallet";
    GdsIcons["ICO_WARNING_XL"] = "ico-warning-xl";
    GdsIcons["ICO_WARNING"] = "ico-warning";
    GdsIcons["ICO_WATCH_NFC_PAYMENT_XL"] = "ico-watch-nfc-payment-xl";
    GdsIcons["ICO_WATCH_NFC_PAYMENT"] = "ico-watch-nfc-payment";
    GdsIcons["ICO_WATER_XL"] = "ico-water-xl";
    GdsIcons["ICO_WATER"] = "ico-water";
    GdsIcons["ICO_WEB_CARDS_NEW_ACTIVE_XL"] = "ico-web-cards-new-active-xl";
    GdsIcons["ICO_WEB_CARDS_NEW_ACTIVE"] = "ico-web-cards-new-active";
    GdsIcons["ICO_WEB_CARDS_NEW_XL"] = "ico-web-cards-new-xl";
    GdsIcons["ICO_WEB_CARDS_NEW"] = "ico-web-cards-new";
    GdsIcons["ICO_WEB_CARDS_XL"] = "ico-web-cards-xl";
    GdsIcons["ICO_WEB_CARDS"] = "ico-web-cards";
    GdsIcons["ICO_WEB_LIST_NEW_ACTIVE_XL"] = "ico-web-list-new-active-xl";
    GdsIcons["ICO_WEB_LIST_NEW_ACTIVE"] = "ico-web-list-new-active";
    GdsIcons["ICO_WEB_LIST_NEW_XL"] = "ico-web-list-new-xl";
    GdsIcons["ICO_WEB_LIST_NEW"] = "ico-web-list-new";
    GdsIcons["ICO_WEB_LIST_XL"] = "ico-web-list-xl";
    GdsIcons["ICO_WEB_LIST"] = "ico-web-list";
    GdsIcons["ICO_WORLD_XL"] = "ico-world-xl";
    GdsIcons["ICO_WORLD"] = "ico-world";
    GdsIcons["ICO_YOUTUBE_XL"] = "ico-youtube-xl";
    GdsIcons["ICO_YOUTUBE"] = "ico-youtube";
    GdsIcons["ICO_ZOOM_IN_XL"] = "ico-zoom-in-xl";
    GdsIcons["ICO_ZOOM_IN"] = "ico-zoom-in";
    GdsIcons["ICO_ZOOM_OUT_XL"] = "ico-zoom-out-xl";
    GdsIcons["ICO_ZOOM_OUT"] = "ico-zoom-out";
})(GdsIcons || (GdsIcons = {}));

var IdsIcons;
(function (IdsIcons) {
    IdsIcons["IDS_ADVISOR_XL"] = "ids-advisor-xl";
    IdsIcons["IDS_ADVISOR"] = "ids-advisor";
    IdsIcons["IDS_AGILE_XL"] = "ids-agile-xl";
    IdsIcons["IDS_AGILE"] = "ids-agile";
    IdsIcons["IDS_ARROW_CIRCLE_DOWN_XL"] = "ids-arrow-circle-down-xl";
    IdsIcons["IDS_ARROW_CIRCLE_DOWN"] = "ids-arrow-circle-down";
    IdsIcons["IDS_ARROW_DOWN_LEFT_XL"] = "ids-arrow-down-left-xl";
    IdsIcons["IDS_ARROW_DOWN_LEFT"] = "ids-arrow-down-left";
    IdsIcons["IDS_ARROW_DOWN_RIGHT_XL"] = "ids-arrow-down-right-xl";
    IdsIcons["IDS_ARROW_DOWN_RIGHT"] = "ids-arrow-down-right";
    IdsIcons["IDS_ARROW_ELBOW_DOWN_LEFT_XL"] = "ids-arrow-elbow-down-left-xl";
    IdsIcons["IDS_ARROW_ELBOW_DOWN_LEFT"] = "ids-arrow-elbow-down-left";
    IdsIcons["IDS_ARROW_ELBOW_DOWN_RIGHT_XL"] = "ids-arrow-elbow-down-right-xl";
    IdsIcons["IDS_ARROW_ELBOW_DOWN_RIGHT"] = "ids-arrow-elbow-down-right";
    IdsIcons["IDS_ARROW_ELBOW_LEFT_DOWN_XL"] = "ids-arrow-elbow-left-down-xl";
    IdsIcons["IDS_ARROW_ELBOW_LEFT_DOWN"] = "ids-arrow-elbow-left-down";
    IdsIcons["IDS_ARROW_ELBOW_LEFT_UP_XL"] = "ids-arrow-elbow-left-up-xl";
    IdsIcons["IDS_ARROW_ELBOW_LEFT_UP"] = "ids-arrow-elbow-left-up";
    IdsIcons["IDS_ARROW_ELBOW_RIGHT_DOWN_XL"] = "ids-arrow-elbow-right-down-xl";
    IdsIcons["IDS_ARROW_ELBOW_RIGHT_DOWN"] = "ids-arrow-elbow-right-down";
    IdsIcons["IDS_ARROW_ELBOW_RIGHT_UP_XL"] = "ids-arrow-elbow-right-up-xl";
    IdsIcons["IDS_ARROW_ELBOW_RIGHT_UP"] = "ids-arrow-elbow-right-up";
    IdsIcons["IDS_ARROW_ELBOW_UP_LEFT_XL"] = "ids-arrow-elbow-up-left-xl";
    IdsIcons["IDS_ARROW_ELBOW_UP_LEFT"] = "ids-arrow-elbow-up-left";
    IdsIcons["IDS_ARROW_ELBOW_UP_RIGHT_XL"] = "ids-arrow-elbow-up-right-xl";
    IdsIcons["IDS_ARROW_ELBOW_UP_RIGHT"] = "ids-arrow-elbow-up-right";
    IdsIcons["IDS_ARROW_UP_LEFT_XL"] = "ids-arrow-up-left-xl";
    IdsIcons["IDS_ARROW_UP_LEFT"] = "ids-arrow-up-left";
    IdsIcons["IDS_ARROW_UP_RIGHT_XL"] = "ids-arrow-up-right-xl";
    IdsIcons["IDS_ARROW_UP_RIGHT"] = "ids-arrow-up-right";
    IdsIcons["IDS_BOOK_OPEN_XL"] = "ids-book-open-xl";
    IdsIcons["IDS_BOOK_OPEN"] = "ids-book-open";
    IdsIcons["IDS_BOOK_XL"] = "ids-book-xl";
    IdsIcons["IDS_BOOK"] = "ids-book";
    IdsIcons["IDS_BUG_XL"] = "ids-bug-xl";
    IdsIcons["IDS_BUG"] = "ids-bug";
    IdsIcons["IDS_CARET_DOUBLE_DOWN_XL"] = "ids-caret-double-down-xl";
    IdsIcons["IDS_CARET_DOUBLE_DOWN"] = "ids-caret-double-down";
    IdsIcons["IDS_CARET_DOUBLE_LEFT_XL"] = "ids-caret-double-left-xl";
    IdsIcons["IDS_CARET_DOUBLE_LEFT"] = "ids-caret-double-left";
    IdsIcons["IDS_CARET_DOUBLE_UP_XL"] = "ids-caret-double-up-xl";
    IdsIcons["IDS_CARET_DOUBLE_UP"] = "ids-caret-double-up";
    IdsIcons["IDS_CODE_XL"] = "ids-code-xl";
    IdsIcons["IDS_CODE"] = "ids-code";
    IdsIcons["IDS_COMMENTS_FEEDBACK_XL"] = "ids-comments-feedback-xl";
    IdsIcons["IDS_COMMENTS_FEEDBACK"] = "ids-comments-feedback";
    IdsIcons["IDS_COMPUTER_ARROW_XL"] = "ids-computer-arrow-xl";
    IdsIcons["IDS_COMPUTER_ARROW"] = "ids-computer-arrow";
    IdsIcons["IDS_CURRENCY_CK_XL"] = "ids-currency-ck-xl";
    IdsIcons["IDS_CURRENCY_CK"] = "ids-currency-ck";
    IdsIcons["IDS_EDUCATION_XL"] = "ids-education-xl";
    IdsIcons["IDS_EDUCATION"] = "ids-education";
    IdsIcons["IDS_EMOJI_XL"] = "ids-emoji-xl";
    IdsIcons["IDS_EMOJI"] = "ids-emoji";
    IdsIcons["IDS_FILE_TEXT_XL"] = "ids-file-text-xl";
    IdsIcons["IDS_FILE_TEXT"] = "ids-file-text";
    IdsIcons["IDS_FLAG_XL"] = "ids-flag-xl";
    IdsIcons["IDS_FLAG"] = "ids-flag";
    IdsIcons["IDS_FLOORPLAN_XL"] = "ids-floorplan-xl";
    IdsIcons["IDS_FLOORPLAN"] = "ids-floorplan";
    IdsIcons["IDS_FURNITURE_CHAIR_XL"] = "ids-furniture-chair-xl";
    IdsIcons["IDS_FURNITURE_CHAIR"] = "ids-furniture-chair";
    IdsIcons["IDS_GEORGE_ID_XL"] = "ids-george-id-xl";
    IdsIcons["IDS_GIT_FORK_XL"] = "ids-git-fork-xl";
    IdsIcons["IDS_GIT_FORK"] = "ids-git-fork";
    IdsIcons["IDS_HARDWARE_XL"] = "ids-hardware-xl";
    IdsIcons["IDS_HARDWARE"] = "ids-hardware";
    IdsIcons["IDS_HEART_XL"] = "ids-heart-xl";
    IdsIcons["IDS_HEART"] = "ids-heart";
    IdsIcons["IDS_HOUSE_DOCUMENT_XL"] = "ids-house-document-xl";
    IdsIcons["IDS_HOUSE_DOCUMENT"] = "ids-house-document";
    IdsIcons["IDS_HR_XL"] = "ids-hr-xl";
    IdsIcons["IDS_HR"] = "ids-hr";
    IdsIcons["IDS_ICON_SECURITY_XL"] = "ids-icon_security-xl";
    IdsIcons["IDS_ICON_SECURITY"] = "ids-icon_security";
    IdsIcons["IDS_INSURANCE_PLUS_XL"] = "ids-insurance-plus-xl";
    IdsIcons["IDS_INSURANCE_PLUS"] = "ids-insurance-plus";
    IdsIcons["IDS_LEGISLATION_XL"] = "ids-legislation-xl";
    IdsIcons["IDS_LEGISLATION"] = "ids-legislation";
    IdsIcons["IDS_LIGHT_XL"] = "ids-light-xl";
    IdsIcons["IDS_LIGHT"] = "ids-light";
    IdsIcons["IDS_LOGOUT_XL"] = "ids-logout-xl";
    IdsIcons["IDS_LOGOUT"] = "ids-logout";
    IdsIcons["IDS_M2_XL"] = "ids-m2-xl";
    IdsIcons["IDS_M2"] = "ids-m2";
    IdsIcons["IDS_MICROPHONE_XL"] = "ids-microphone-xl";
    IdsIcons["IDS_MICROPHONE"] = "ids-microphone";
    IdsIcons["IDS_MOBILE_EMAIL_XL"] = "ids-mobile-email-xl";
    IdsIcons["IDS_MOBILE_EMAIL"] = "ids-mobile-email";
    IdsIcons["IDS_NO_CONTENT_XL"] = "ids-no-content-xl";
    IdsIcons["IDS_NO_CONTENT"] = "ids-no-content";
    IdsIcons["IDS_ONLINE_BANKER_XL"] = "ids-online-banker-xl";
    IdsIcons["IDS_ONLINE_BANKER"] = "ids-online-banker";
    IdsIcons["IDS_ONLINE_MEETING_XL"] = "ids-online-meeting-xl";
    IdsIcons["IDS_ONLINE_MEETING"] = "ids-online-meeting";
    IdsIcons["IDS_ORGANISATIONAL_STRUCTURE"] = "ids-organisational-structure";
    IdsIcons["IDS_PAINTING_XL"] = "ids-painting-xl";
    IdsIcons["IDS_PAINTING"] = "ids-painting";
    IdsIcons["IDS_PERCENT_XL"] = "ids-percent-xl";
    IdsIcons["IDS_PERCENT"] = "ids-percent";
    IdsIcons["IDS_PICK_DATE_XL"] = "ids-pick-date-xl";
    IdsIcons["IDS_PICK_DATE"] = "ids-pick-date";
    IdsIcons["IDS_PIN_XL"] = "ids-pin-xl";
    IdsIcons["IDS_PIN"] = "ids-pin";
    IdsIcons["IDS_PLUS_CIRCLE_XL"] = "ids-plus-circle-xl";
    IdsIcons["IDS_PLUS_CIRCLE"] = "ids-plus-circle";
    IdsIcons["IDS_PRODUCT_USER_XL"] = "ids-product-user-xl";
    IdsIcons["IDS_PRODUCT_USER"] = "ids-product-user";
    IdsIcons["IDS_PUZZLE_XL"] = "ids-puzzle-xl";
    IdsIcons["IDS_PUZZLE"] = "ids-puzzle";
    IdsIcons["IDS_QUOTES_XL"] = "ids-quotes-xl";
    IdsIcons["IDS_QUOTES"] = "ids-quotes";
    IdsIcons["IDS_REWARD_BADGE_XL"] = "ids-reward-badge-xl";
    IdsIcons["IDS_REWARD_BADGE"] = "ids-reward-badge";
    IdsIcons["IDS_SAVE_FILE_XL"] = "ids-save-file-xl";
    IdsIcons["IDS_SAVE_FILE"] = "ids-save-file";
    IdsIcons["IDS_SEND_XL"] = "ids-send-xl";
    IdsIcons["IDS_SEND"] = "ids-send";
    IdsIcons["IDS_STAMP_XL"] = "ids-stamp-xl";
    IdsIcons["IDS_STAMP"] = "ids-stamp";
    IdsIcons["IDS_SUITCASE_XL"] = "ids-suitcase-xl";
    IdsIcons["IDS_SUITCASE"] = "ids-suitcase";
    IdsIcons["IDS_TABLET_LANDSCAPE_XL"] = "ids-tablet-landscape-xl";
    IdsIcons["IDS_TABLET_LANDSCAPE"] = "ids-tablet-landscape";
    IdsIcons["IDS_TABLET_PORTRAIT_XL"] = "ids-tablet-portrait-xl";
    IdsIcons["IDS_TABLET_PORTRAIT"] = "ids-tablet-portrait";
    IdsIcons["IDS_TARGET_XL"] = "ids-target-xl";
    IdsIcons["IDS_TARGET"] = "ids-target";
    IdsIcons["IDS_TO_BE_ADDED_XL"] = "ids-to-be-added-xl";
    IdsIcons["IDS_TO_BE_ADDED"] = "ids-to-be-added";
    IdsIcons["IDS_TOOLS_XL"] = "ids-tools-xl";
    IdsIcons["IDS_TOOLS"] = "ids-tools";
    IdsIcons["IDS_TRIBE_XL"] = "ids-tribe-xl";
    IdsIcons["IDS_TRIBE"] = "ids-tribe";
    IdsIcons["IDS_UNPIN_XL"] = "ids-unpin-xl";
    IdsIcons["IDS_UNPIN"] = "ids-unpin";
    IdsIcons["IDS_USER_ADD_XL"] = "ids-user-add-xl";
    IdsIcons["IDS_USER_ADD"] = "ids-user-add";
    IdsIcons["IDS_VARIATION_XL"] = "ids-variation-xl";
    IdsIcons["IDS_VARIATION"] = "ids-variation";
    IdsIcons["IDS_WHEELBARROW_XL"] = "ids-wheelbarrow-xl";
    IdsIcons["IDS_WHEELBARROW"] = "ids-wheelbarrow";
    IdsIcons["IDS_WRENCH_XL"] = "ids-wrench-xl";
    IdsIcons["IDS_WRENCH"] = "ids-wrench";
})(IdsIcons || (IdsIcons = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { GdsIcons, IdsIcons, ScIconComponent, ScIconModule };
